export default "__VITE_ASSET__D7P$BIUT__"